<template>
  <div class="full_page">

    <template v-if="compare_60_120_list.show_data === 0">
      <!--    do not show anything  -->
    </template>

    <template v-if="compare_60_120_list.show_data === 1">
    <h2>Compare Sales Total 0-60 Days VS 60-120 Days</h2>

    <div class="row">
      <div class="col-2">
       <label for="min_amount">Limit</label>
       <input
            type="text"
            size="4"
            id="min_amount"
            class="input_field_value"
            :disabled=compare_60_120_list_loading
            :value="min_amount"
            @input="min_amount = $event.target.value"
            @blur="get_compare_list()">
        <label for="min_amount">$</label>
      </div>
      <div class="col-3">
        <label for="percentage_drop">Limit</label>
        <input
            type="text"
            size="2"
            id="percentage_drop"
            class="input_field_value"
            :disabled=compare_60_120_list_loading
            :value="percentage_drop"
            @input="percentage_drop = $event.target.value"
            @blur="get_compare_list()">
        <label for="percentage_drop">% </label>

        <template v-if="plus_minus === 1">
          <button class="action_button" @click="set_plus_minus(0)" :disabled=compare_60_120_list_loading>Switch To Less Sales</button>
        </template>
        <template v-else>
          <button class="action_button" @click="set_plus_minus(1)" :disabled=compare_60_120_list_loading>Switch To More Sales</button>
        </template>

      </div>


      <div class="col-1">
        <template v-if="asc_desc === 'AMOUNT_DESC'">
          <button class="button_set" :disabled=true>Sales Up</button>
        </template>
        <template v-else>
          <button class="action_button" @click="set_button_value('AMOUNT_DESC')" :disabled=compare_60_120_list_loading>Sales Up</button>
        </template>
      </div>
      <div class="col-1">
        <template v-if="asc_desc === 'AMOUNT_ASC'">
          <button class="button_set"  :disabled=true>Sales Down</button>
        </template>
        <template v-else>
          <button class="action_button" @click="set_button_value('AMOUNT_ASC')" :disabled=compare_60_120_list_loading>Sales Down</button>
        </template>
      </div>
      <div class="col-1">
        <template v-if="asc_desc === 'UNITS_DESC'">
          <button class="button_set"  :disabled=true>Units Up</button>
        </template>
        <template v-else>
          <button class="action_button" @click="set_button_value('UNITS_DESC')" :disabled=compare_60_120_list_loading>Units Up</button>
        </template>
      </div>
      <div class="col-1">
        <template v-if="asc_desc === 'UNITS_ASC'">
          <button class="button_set"  :disabled=true>Units Down</button>
        </template>
        <template v-else>
          <button class="action_button" @click="set_button_value('UNITS_ASC')" :disabled=compare_60_120_list_loading>Units Down</button>
        </template>
      </div>

      <div class="col-1">
      </div>

      <div class="col-2">
        <template v-if="compare_60_120_list_loading">
          <button class="update_button" :disabled=true>Updating Calculation ...</button>
        </template>
        <template v-else>
          <button class="update_button" @click="update_calculation()">Update Calculation (15 secs)</button>
        </template>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <table class="table table-striped table-bordered table-hover table-condensed">
          <thead>
          <tr>
            <th>#</th>
            <th>Customer Name</th>
            <th>Sales 60-120 Days</th>
            <th>Sales 0-60 Days</th>
            <th :style="{background: background_color_sales(asc_desc)}">Sales %</th>
            <th>Units 60-120 Days</th>
            <th>Units 0-60 Days</th>
            <th :style="{background: background_color_units(asc_desc)}">Units %</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="customer in compare_60_120_list.data" v-bind:key="customer.customer_id">
            <td>{{customer.position}}</td>
            <td style="cursor: pointer; text-decoration: underline" v-on:click="show_customer_detail_page(customer.customer_id)">{{customer.companyname}}</td>
            <td>${{customer.amount1}}</td>
            <td>${{customer.amount2}}</td>
            <td>{{customer.amount_drop_percentage}}%</td>
            <td>{{customer.units1}}</td>
            <td>{{customer.units2}}</td>
            <td>{{customer.units_drop_percentage}}%</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      min_amount: null,
      percentage_drop: null,
      asc_desc: null,
      plus_minus: 0,
    }
  },
  computed: {
    ...mapGetters({
      compare_60_120_list: 'admin/compare_60_120_list',
      compare_60_120_list_loading: 'admin/compare_60_120_list_loading',
    }),
  },
  mounted() {
     if(localStorage.getItem('compare_asc_desc') === null)
     {
       localStorage.setItem('compare_asc_desc', "AMOUNT_DESC");
     }
    this.asc_desc = localStorage.getItem('compare_asc_desc');

    if(localStorage.getItem('compare_min_amount') === null)
    {
      localStorage.setItem('compare_min_amount', "5000");
    }
    this.min_amount = localStorage.getItem('compare_min_amount');

    if(localStorage.getItem('compare_percentage_drop') === null)
    {
      localStorage.setItem('compare_percentage_drop', "20");
    }
    this.percentage_drop = localStorage.getItem('compare_percentage_drop');

    if(localStorage.getItem('plus_minus') === null)
    {
      localStorage.setItem('plus_minus', "0");
    }
    this.plus_minus = Number(localStorage.getItem('plus_minus'));

    this.get_compare_list();
  },
  methods: {
    get_compare_list () {
      localStorage.setItem('compare_asc_desc', this.asc_desc);
      localStorage.setItem('compare_min_amount', this.min_amount);
      localStorage.setItem('compare_percentage_drop', this.percentage_drop);
      localStorage.setItem('plus_minus', this.plus_minus);
      this.$store.dispatch('admin/getCompare60120List', {'plus_minus': this.plus_minus,'min_amount': this.min_amount, 'percentage_drop': this.percentage_drop, 'asc_desc' : this.asc_desc});
    },
    set_button_value($value) {
      this.asc_desc = $value;
      this.get_compare_list();
    },
    set_plus_minus(plus_minus) {
      this.plus_minus = plus_minus;
      localStorage.setItem('plus_minus', this.plus_minus);
      this.get_compare_list();
    },
    update_calculation () {
      this.$store.dispatch('admin/updateCompare60120List',{'plus_minus': this.plus_minus,'min_amount': this.min_amount, 'percentage_drop': this.percentage_drop, 'asc_desc' : this.asc_desc});
    },
    show_customer_detail_page(customer_id) {
      this.$router.push({name: "customer_details", 'params':{customer_id: customer_id} });
    },
    background_color_sales: function(asc_desc) {
      if(asc_desc === 'AMOUNT_DESC') {
        return 'lightskyblue';
      }
      if(asc_desc === 'AMOUNT_ASC') {
        return 'lightskyblue';
      }
      return null;
    },
    background_color_units: function(asc_desc) {
      if(asc_desc === 'UNITS_DESC') {
        return 'lightskyblue';
      }
      if(asc_desc === 'UNITS_ASC') {
        return 'lightskyblue';
      }
      return null;
    },
  }
}
</script>


<style scoped>

.input_field_value {
  color: black;
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 2px;
  padding-bottom: 2px;
  margin-top: 8px;
  margin-left: 10px;
  margin-right: 10px;
  border-radius: 4px;
  border-color: blue;
  font-size: larger;
  font-weight: 400;
}

.update_button {
  color: black;
  background-color: lightcoral;
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 5px;
  padding-bottom: 4px;
  border-radius: 5px;
  border-style: hidden;
  font-weight: 500;
  margin-top: 10px;
  margin-bottom: 10px;
}

.action_button {
  color: black;
  background-color: lightskyblue;
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 5px;
  padding-bottom: 4px;
  border-radius: 5px;
  border-style: hidden;
  font-weight: 500;
  margin-top: 10px;
  margin-left: 10px;
  margin-bottom: 10px;
}

.button_set {
  color: white;
  background-color: lightskyblue;
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 5px;
  padding-bottom: 4px;
  border-radius: 5px;
  border-style: hidden;
  font-weight: 500;
  margin-top: 10px;
  margin-bottom: 10px;
}

.full_page {
  margin-left: 20px;
  margin-right: 20px;
}

</style>

